import { render, staticRenderFns } from "./PapelSegurancaConsumo.vue?vue&type=template&id=24751c56&"
import script from "./PapelSegurancaConsumo.vue?vue&type=script&lang=js&"
export * from "./PapelSegurancaConsumo.vue?vue&type=script&lang=js&"
import style0 from "./PapelSegurancaConsumo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports